import React from 'react';
import './aside.css';
import Navlink from './navlink';
import { ReactComponent as DashboardIcon } from '../assets/dashboard.svg';
import { ReactComponent as ProgramsIcon } from '../assets/programs.svg';
import { ReactComponent as BookingsIcon } from '../assets/booking.svg';
import { ReactComponent as CategoriesIcon } from '../assets/categories.svg';
import { ReactComponent as UsersIcon } from '../assets/users.svg';
import { ReactComponent as FeedbackIcon } from '../assets/feedback.svg';
import { ReactComponent as ContentIcon } from '../assets/contentmanagment.svg';
import { ReactComponent as TicketIcon } from '../assets/tickets.svg';
import { ReactComponent as BoothIcon } from '../assets/booths.svg';
import { ReactComponent as MessageIcon } from '../assets/supportmessages.svg';
import { ReactComponent as NotificationIcon } from '../assets/notification.svg';
import { ReactComponent as StartupsIcon } from '../assets/startups.svg';
import logo from '../assets/logo.png';

const Aside = ({ isOpen, setIsOpen }) => {
  const links = [
    { text: 'Dashboard', to: '/dashboard', icon: DashboardIcon },
    { text: 'Users', to: '/users', icon: UsersIcon },
    { text: 'Bookings', to: '/bookings', icon: BookingsIcon },
    { text: 'Tickets', to: '/tickets', icon: TicketIcon },
    { text: 'Categories', to: '/categories', icon: CategoriesIcon },
    { text: 'Programs', to: '/programs', icon: ProgramsIcon },
    { text: 'Startups', to: '/startups', icon: StartupsIcon },
    { text: 'Booths', to: '/booths', icon: BoothIcon },
    { text: 'Content', to: '/content', icon: ContentIcon, aliases: ['/content-management'] },
    { text: 'Feedback', to: '/feedback', icon: FeedbackIcon },
    { text: 'Notifications', to: '/notifications', icon: NotificationIcon },
    { text: 'Call Logs', to: '/call-logs', icon: MessageIcon },
  ];

  return (
    <>
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <a className="sidebar_brand" href="/dashboard">
          <img className="sidebar_brand_logo" alt="TECHNE" src={logo} />
        </a>

        <nav className="sidebar_nav" aria-label="Primary navigation">
          <ul className="sidebar_menu">
            {links.map((link) => (
              <Navlink
                aliases={link.aliases}
                icon={link.icon}
                key={link.to}
                linktext={link.text}
                to={link.to}
              />
            ))}
          </ul>
        </nav>
      </aside>

      {isOpen && (
        <button
          aria-label="Close sidebar"
          className="sidebar_overlay"
          onClick={() => setIsOpen(false)}
          type="button"
        />
      )}
    </>
  );
};

export default Aside;
